import BaseStore from '@/store';
import { createNamespacedHelpers } from 'vuex';
import actions from './loadPlanningList.actions.js';
import getters from './loadPlanningList.getters.js';
import mutations from './loadPlanningList.mutations.js';
import state from './loadPlanningList.state.js';

import orderSearch from '../OrderSearch/store/OrderSearch.store.js';
import tripSearch from '../TripSearch/store/TripSearch.store.js';

let store = {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
	modules: {
		orderSearch,
		tripSearch
	}
};

export default store;

export let { mapGetters, mapMutations, mapActions, mapState } = createNamespacedHelpers('loadPlanning');

export function tryRegisterStoreDynamically(id) {
	let path = `loadPlanning/${  id  }/`;

	if (path in BaseStore._modulesNamespaceMap) {
		return false;
	}

	BaseStore.registerModule(path.slice(0, -1), store);
	return true;
}

